import React from 'react';
import { PET_STICKER_IMAGES } from './petStickerImages';

// Slight, alternating tilts so the row reads as stuck-on stickers rather
// than a uniform grid.
const ROTATIONS = [-6, 3, -3, 6, -4, 5, -5, 4, -2, 2];

function splitIntoRows(images) {
  const rowA = [];
  const rowB = [];
  images.forEach((src, i) => {
    (i % 2 === 0 ? rowA : rowB).push(src);
  });
  return [rowA, rowB];
}

function StickerRow({ images, reverse, altLabel }) {
  // Duplicated once so the CSS loop (translateX 0 -> -50%) is seamless.
  const looped = [...images, ...images];

  return (
    <div className="pet-marquee-row">
      <div className={`pet-marquee-track${reverse ? ' pet-marquee-track--reverse' : ''}`}>
        {looped.map((src, i) => (
          <div
            key={`${src}-${i}`}
            className="pet-sticker"
            style={{ '--rot': `${ROTATIONS[i % ROTATIONS.length]}deg` }}
          >
            <img
              src={src}
              alt={altLabel}
              className="pet-sticker-img h-20 w-20 sm:h-28 sm:w-28 object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PetLoveMarquee({ heading, altLabel }) {
  const [rowA, rowB] = splitIntoRows(PET_STICKER_IMAGES);

  return (
    <div className="w-full bg-bgSkin mt-16 py-16 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-8 lg:px-16 text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-brownSkin leading-tight max-w-2xl mx-auto">
          {heading}
        </h2>
      </div>

      <div className="space-y-5 sm:space-y-7">
        <StickerRow images={rowA} altLabel={altLabel} />
        <StickerRow images={rowB} reverse altLabel={altLabel} />
      </div>
    </div>
  );
}
